"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Cached_1 = __importDefault(require("@material-ui/icons/Cached"));
require("./TransactionType.css");
var TransactionType = function (_a) {
    var type = _a.type, paymentsLeft = _a.paymentsLeft;
    return (react_1.default.createElement("div", { className: "transaction-type" },
        react_1.default.createElement("span", null, type),
        paymentsLeft ? react_1.default.createElement(Cached_1.default, null) : null,
        paymentsLeft ? (react_1.default.createElement("span", { className: "payments-left" }, paymentsLeft)) : null));
};
exports.default = TransactionType;
